import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { LoadingController, ModalController, ToastController } from '@ionic/angular';
import { ServicesProvider } from 'src/providers/services';
import { DatePikerPage } from '../date-piker/date-piker.page';
import { CommenAlertpagePage } from '../register/commen-alertpage/commen-alertpage.page';
import { AddCall } from 'src/providers/addvCall';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { HttpClient, HttpParams } from '@angular/common/http';
import * as CryptoJS from 'crypto-js';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import * as htmlToPdfmake from 'html-to-pdfmake';
import { File } from '@ionic-native/file/ngx';
import { FileOpener } from '@ionic-native/file-opener/ngx';
// pdfMake.vfs = pdfFonts.pdfMake.vfs;
interface DecryptedMemberContentResponse {
  data: { Terms_and_conditions: string }[];
}


@Component({
  selector: 'app-register',
  templateUrl: './register.page.html',
  styleUrls: ['./register.page.scss'],
})
export class RegisterPage implements OnInit {
  private fkey = CryptoJS.enc.Hex.parse(
    '00112233445566778899aabbccddeeff00112233445566778899aabbccddeeff'
  );
  private fiv = CryptoJS.enc.Hex.parse('00112233445566778899aabbccddeeff');
  searchData: { costValue: any; distance: any; offers: any; selectedDate: any; };
  getCountryCode: string = null;
  CCode: { CC: string; CCV: number; CCName: string; }[];
  getGender: any = null;
  getName: any = null;
  getDOB: any = null;
  getPhNo: any = null;
  getCodeNo:any = null;
  getEmail: any = null;
  getAdd: any = null;
  toastMessage: any;
  Date: any = null;
  getMaxLength: any;
  setDate: string;
  selectedDate: any;
  getReferralCode: any = null;
  responseDetails: any[] = []; // Assuming responseDetails is an array of referral code details from the API
  referralCodeInvalid: boolean = false;
  isConfirmed = false;
  pdfopen:boolean = true
  validationAttempted: boolean = false;
  terms_and_condition_file : any;

  validationResult: boolean | undefined = undefined;
  referralCodeValid: boolean = false;
  emailContent_data: any;
  imgBase64: string;
  documentDefinition: { content: any; styles: { header: { fontSize: number; bold: boolean; margin: number[]; }; footer: { fontSize: number; margin: number[]; }; footerText: { fontSize: number; }; }; header: (currentPage: any, pageCount: any, pageSize: any) => { text: string; alignment: string; style: string; color: string; margin: number[]; }; footer: (currentPage: any, pageCount: any, pageSize: any) => { margin: number[]; columns: { stack: ({ columns: { text: string; alignment: string; color: string; margin: number[]; }[]; columnGap: number; text?: undefined; alignment?: undefined; color?: undefined; style?: undefined; } | { columns: ({ text: any; alignment: string; color: string; width: number; margin: number[]; image?: undefined; height?: undefined; } | { image: string; width: number; height: number; margin: number[]; alignment: string; text?: undefined; color?: undefined; })[]; columnGap: number; text?: undefined; alignment?: undefined; color?: undefined; style?: undefined; } | { columns: { text: string; width: number; color: string; margin: number[]; }[]; columnGap: number; text?: undefined; alignment?: undefined; color?: undefined; style?: undefined; } | { text: string; alignment: string; color: string; style: string; columns?: undefined; columnGap?: undefined; })[]; }[]; }; pageMargins: number[]; };



  constructor(
    public router: Router,
    public modalCtrl: ModalController,
    private services: ServicesProvider,
    public toastController: ToastController,
    public loadingController: LoadingController,
    private datePipe: DatePipe,
    public addCall: AddCall,
    private http: HttpClient,
    private file: File,
    private fileOpener: FileOpener
  ) { }
  ngOnInit() {
    this.CCode =
      [{
        CC: "+965",
        CCV: 965,
        CCName: "Kuwait"
      },
      {
        CC: "+91",
        CCV: 91,
        CCName: "Kuwait"
      },        
      ]
      debugger;
    this.getCountryCode = this.getCodeNo;
    this.getMaxLength = this.getCodeNo == "91" ? 10 : 8;
    console.log(this.getCountryCode);
  }

  triggerCountryCodeEvent() {
    debugger;
    this.getPhNo = '';
    if (this.getCountryCode == "965") {
      this.getMaxLength = 8;
    } else if (this.getCountryCode == "91") {
      this.getMaxLength = 10;
    }
  }

  ionViewWillEnter() {
    this.getReferralCodeList()
    this.Date = null;
  }

  async openDatePicker() {
    const datePickerModal = await this.modalCtrl.create({
      component: DatePikerPage,
      cssClass: 'datePicker',
      componentProps: {
        'selectedDate': this.selectedDate,
        'calenderType': "dob"    //normal/dob
      }
    });
    await datePickerModal.present();

    datePickerModal.onDidDismiss()
      .then((data) => {
        console.log(data);
        if (data.data) {
         
          this.Date = data.data
          this.setDate = this.Date.getFullYear() + "-" + (this.Date.getMonth() + 1) + "-" + this.Date.getDate();
        }
        this.Date = this.getFormattedDateTime(this.Date, "Date");
        console.log("selectedDate=>", this.setDate);
        this.getDOB = this.setDate;
      });
  }

  async showsuccessmodel(msg, sta) {
    const popup = await this.modalCtrl.create({
      component: CommenAlertpagePage,
      cssClass: 'showalert',
      componentProps: {
        msg: msg,
        status: sta
      },

    });

    await popup.present();

    this.modalCtrl.dismiss();

    //}, 5000);


  }

  async presentToast() {
    const toast = await this.toastController.create({
      message: this.toastMessage,
      duration: 2000,
      cssClass: 'toastStyle',
    });
    toast.present();
  }

  dismiss(value) {
    this.searchData = {
      "costValue": "kk",
      "distance": "kk",
      "offers": "j",
      "selectedDate": "k"
    };
    if (value == "search") {
      this.modalCtrl.dismiss(this.searchData);
    }
    else {
      this.modalCtrl.dismiss();
    }
  }


  decryptContent(encryptedContent: string): string {
    try {
      const decryptedBytes = CryptoJS.AES.decrypt(encryptedContent, this.fkey, {
        iv: this.fiv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });
      return decryptedBytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      return error.message;
    }
  }
  formatDate(date: Date): string {
    const day = date.getDate().toString().padStart(2, '0');
    const monthNames = [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear().toString().slice(-2);
    return `${day}-${month}-${year}`;
  }
  async convertImageToBase64(file) {
    try {
      const imageUrlData = await fetch(file);
      const buffer = await imageUrlData.arrayBuffer();
      const base64String = btoa(
        new Uint8Array(buffer)
          .reduce((data, byte) => data + String.fromCharCode(byte), '')
      );
      const contentType = file.endsWith('.jpg') || file.endsWith('.jpeg') ? 'image/jpeg' : 'image/png';
      return `data:${contentType};base64,${base64String}`;
    } catch (error) {
      console.error("Image conversion error:", error);
      return "";
    }
  }

  openTerms() {
    const url = this.services.apiURL() + 'admin/decryptedMemberContent_data';
    const params = new HttpParams().set('vendorcategory', 'Tom');
    
    this.http.get<DecryptedMemberContentResponse>(url, { params })
      .subscribe(
        async response => {
          if (response && response.data && response.data.length > 0) {
            const lastIndex = response.data.length - 1;
            this.terms_and_condition_file = response.data[lastIndex].Terms_and_conditions;
            const decryptedData = this.decryptContent(this.terms_and_condition_file);
            console.log("Decrypted data:", decryptedData);
            
            if (!decryptedData) {
              throw new Error('Decryption failed');
            }
            
            const content = htmlToPdfmake(decryptedData);
            const imgToBase64Url = '/assets/img/tick_mark.png';
            
            try {
              this.imgBase64 = await this.convertImageToBase64(imgToBase64Url);
              if (!this.imgBase64) {
                throw new Error('Image conversion failed');
              }
              console.log("Image Base64:", this.imgBase64);
            } catch (error) {
              console.error('Error converting image to Base64:', error);
              this.imgBase64 = ''; // Set a fallback in case of error
            }
     
            this.documentDefinition = {
              content: content,
              styles: {
                header: {
                  fontSize: 12,
                  bold: true,
                  margin: [40, 10, 40, 10],
                },
                footer: {
                  fontSize: 10,
                  margin: [40, 0, 40, 0],
                },
                footerText: {
                  fontSize: 10,
                },
              },
              header: (currentPage, pageCount, pageSize) => {
                return {
                  text: ``,
                  alignment: 'left',
                  style: 'header',
                  color: '#510F30',
                  margin: [30, 40, 0, 0],
                };
              },
              footer: (currentPage, pageCount, pageSize) => {
                const modified_on = new Date();
                if (this.pdfopen == true) {
                  return {
                    margin: [40, 0, 40, 40],
                    columns: [
                      {
                        stack: [
                          {
                            text: `Page ${currentPage} of ${pageCount}`,
                            alignment: "right",
                            color: "#510F30",
                            style: "footerText",
                          },
                        ],
                      },
                    ],
                  };
                } else {
                  return {
                    margin: [40, 0, 40, 40],
                    columns: [
                      {
                        stack: [
                          {
                            columns: [
                              {
                                text: "Member Signature",
                                alignment: "left",
                                color: "#510F30",
                                margin: [0, 15, 0, 0],
                              },
                            ],
                            columnGap: 10,
                          },
                          {
                            columns: [
                              {
                                text: this.getName,
                                alignment: "left",
                                color: "#510F30",
                                width:130,
                                margin: [0, 15, 0, 0],
                              },
                              {
                                image: this.imgBase64,
                                width: 25,
                                height: 25,
                                margin: [0, 10, 0, 0],
                                alignment: "left",
                              },
                            ],
                            columnGap: 2,
                          },
                          {
                            columns: [
                              {
                                text: "Registration Date: " + this.formatDate(modified_on),
                                alignment: "left",
                                color: "#510F30",
                                margin: [0, 15, 0, 0],
                              },
                            ],
                            columnGap: 2,
                          },
                          {
                            columns: [
                              {
                                text: "Mobile Number: " + this.getPhNo,
                                width: 300,
                                color: "#510F30",
                                margin: [0, 15, 0, 0],
                              },
                            ],
                            columnGap: 2,
                          },
                          {
                            text: `Page ${currentPage} of ${pageCount}`,
                            alignment: "right",
                            color: "#510F30",
                            style: "footerText",
                          },
                        ],
                      },
                    ],
                  };
                }
              },
              pageMargins: [40, 70, 40, 180],
            };
            
            pdfMake.createPdf(this.documentDefinition).getBlob(async (blob: Blob) => {
              console.log("PDF Blob:", blob);
              try {
                if (this.pdfopen == true) {
                  const localBlob = new Blob([blob], { type: 'application/pdf' });
                  const fileName = `report_${new Date().getTime()}.pdf`;
                  await this.file.writeFile(this.file.dataDirectory, fileName, localBlob, { replace: true })
                    .then((fileEntry) => {
                      console.log("File entry:", fileEntry);
                      this.fileOpener.open(fileEntry.nativeURL, 'application/pdf')
                        .then(() => console.log('File is opened'))
                        .catch(e => console.log('Error opening file', e));
                    })
                    .catch(e => console.log('Error writing file', e));
                } else {
                  const formData = new FormData();
                  formData.append('module_id', "66");
                  formData.append('file', blob, 'document.pdf');
                  formData.append('pathLocation', "PROFILE/");
                  
                  this.services.imageUploadS3Bucket("admin/awsS3FileUpload", formData).subscribe(response => {
                    let apiData1 = {
                      filepath: response.filepath.Location,
                      name: this.getName,
                      email: [this.getEmail, "thanesh@avelator.com"],
                      vendorContranct: "vendorContranct"
                    };
                    
                    this.http.post<any>(this.services.apiURL() + 'admin/decryptedContent_member_details', apiData1).subscribe(data => {
                      console.log("dataaa", data);
                    }, error => {
                      console.error("Error in post request:", error);
                    });
                  }, error => {
                    console.error("Error uploading file:", error);
                  });
                }
              } catch (error) {
                console.error('Error uploading file', error);
              }
            });
          } else {
            console.error('Unexpected response format:', response);
          }
        },
        error => {
          console.error('Error:', error);
        }
      );
  }
  selectGender(value) {
    this.getGender = value;
  }

  closePage() {
    this.modalCtrl.dismiss();
  }

  async insertDetails() {
    if (this.getPhNo != null) {
      this.pdfopen = false
      let dob = moment(this.getDOB).format('YYYY-MM-DD')
      console.log("dob", dob, this.getDOB);
      let apiData = JSON.stringify({
        "name": this.getName,
        "dob": dob,
        "email": this.getEmail,
        "ccode": this.getCountryCode,
        "phone_no": this.getPhNo,
        "gender": this.getGender,
        "address": "",//this.getAdd
        "referral_code": this.getReferralCode,
      });
      this.services.postRequest("insertPatientDetails", apiData).subscribe(async res => {
        console.log(res);
        if (res.status == 1) {
          this.pdfopen = false
          this.toastMessage = this.addCall.title528;
          this.presentToast();
          this.openTerms()
        }
        else {
          this.toastMessage = res.msg;
          this.presentToast();
        }
        this.modalCtrl.dismiss();
      });
    }
  }


getReferralCodeList() {
  this.services.getRequest("getReferralCodeList").subscribe(async (response: any) => {
    if (response && response.data && response.data.length > 0 && response.data[0].details) {
      this.responseDetails = response.data[0].details;
      console.log("responseDetails", this.responseDetails);
    } else {
      console.error("Error occurred while fetching referral codes: Invalid response structure");
    }
  }, error => {
    console.error("Error occurred while fetching referral codes:", error);
  });
}

  getFormattedDateTime(dateTime, callFor) {
    if (!dateTime) {
      return "";
    }
    var Value;
    switch (callFor) {
      case "Time":
        if (dateTime.indexOf("T") > -1) {
          Value = dateTime.split("T")[1];
        } else if (dateTime.indexOf(" ") > -1) {
          Value = dateTime.split(" ")[1];
        } else {
          Value = dateTime;
        }
        var hourEnd = Value.indexOf(":");
        var H = +String(Value).substr(0, hourEnd);
        var h = H % 12 || 12;
        var ampm = (H < 12 || H === 24) ? "AM" : "PM";
        let timeString = h + String(Value).substr(hourEnd, 3) + " " + ampm;
        return timeString;
      case "Date":
        return this.datepipeTransform(new Date(dateTime), "dd MMM yyyy");
      case "DateTime":
        return this.datepipeTransform(new Date(dateTime), "dd MMM yyyy h:mm a");
    }
  }

  datepipeTransform(date: any, format: string): any {
    return this.datePipe.transform(date, format);
  }

  validate() {
    this.validationResult = this.validateEmail(this.getEmail);
  }

  validateEmail(email: string): boolean {
    const pattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    return pattern.test(email);
  }


  insertMemberDetails() {
    debugger
    this.validationAttempted = true;
    this.validateReferralCode();
    const allFieldsValid = this.getName && this.getGender && this.getDOB && this.getEmail && this.getPhNo;
    if (allFieldsValid) {
      this.insertDetails();
    } else {
      console.log("Validation failed. Please check the input fields.");
    }
  }

  validateReferralCode() {
    debugger
    if (!this.getPhNo) {
      this.referralCodeInvalid = false;
      this.referralCodeValid = true;
      return;
    }
    const matchedMemberNumber = this.responseDetails.some(
      detail => detail.member_number === this.getPhNo
    );
    if (matchedMemberNumber) {
      const found = this.responseDetails.some(
        detail => detail.referral_code === this.getReferralCode && detail.member_number === this.getPhNo
      );
      this.referralCodeInvalid = !found;
      this.referralCodeValid = found;
    } else {
      if (this.getReferralCode) {
        const found = this.responseDetails.some(
          detail => detail.referral_code === this.getReferralCode
        );
        this.referralCodeInvalid = !found;
        this.referralCodeValid = found;
      } else {
        this.referralCodeInvalid = false;
        this.referralCodeValid = true;
      }
    }
}
}